import { render } from "./wokerDetail16.vue?vue&type=template&id=13ed52f2&scoped=true"
import script from "./wokerDetail16.vue?vue&type=script&lang=js"
export * from "./wokerDetail16.vue?vue&type=script&lang=js"

import "./wokerDetail16.vue?vue&type=style&index=0&id=13ed52f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ed52f2"]])

export default __exports__